/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'utils/translates';
import {
  selectUserId,
  selectCreatedAt,
  selectFullName,
  selectLastAuthAt,
  selectRating,
  selectUserName,
  selectBirthDtYearsOld,
  selectGenderLabel,
  selectReferrer,
  selectLocation,
  selectTasksCountStat,
  selectReferralsCountStat,
  selectCommentsInCountStat,
  selectCommentsOutCountStat,
  selectAvatarPath
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import * as formatter from 'mt-react-common/utils/formatter';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import ListItemLink from '../../../../../../components/Common/ListItemLink/ListItemLink';
import RatingStars from '../../../../../../components/Rating/RatingStars/RatingStars';

class UserInfoBlock extends Component {
  componentWillUnmount() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip('hide');
  }

  render() {
    return (
      <React.Fragment>
        <div className="panel panel-default panel-footer_bg-sub panel-heading_padding-large">
          <div className="panel-heading text-center">
            <h1 className="panel-title">
              <div className="hidden-xs">
                <i className="fa fa-user-circle-o" /> {this.props.userName}
              </div>
              <div className="media media_inline-table media-left_padding-xs hidden-sm hidden-md hidden-lg">
                <div className="media-left">
                  <img
                    alt=""
                    src={this.props.avatarPath}
                    className="media-object avatar avatar-sm avatar_bordered"
                  />
                </div>
                <div className="media-body media-middle text-left">
                  <div
                    className="text-caption font-size-xxs text-caption text-success"
                    data-toggle="tooltip"
                    data-container="body"
                    data-placement="top"
                    title={`${t('Рейтинг')}: ${
                      this.props.rating.ratingStatusPoints
                    }/${this.props.rating.ratingStatusPointsTo} (${
                      this.props.rating.ratingStatusTitle
                    })`}
                  >
                    <RatingStars rating={this.props.rating.rating} />{' '}
                    {this.props.rating.ratingStatusTitle}
                  </div>
                  <strong>{this.props.userName}</strong>
                </div>
              </div>
            </h1>
          </div>
          <div className="panel-body">
            <dl className="dl-horizontal dl-options center-block max-w-400">
              <dt>
                <i className="fa fa-id-card-o" /> ID:
              </dt>
              <dd>{formatter.emptyReplace(this.props.userId)}</dd>
              <dt>
                <i className="fa fa-id-card" /> {t('Имя')}:
              </dt>
              <dd>{formatter.emptyReplace(this.props.fullName)}</dd>
              <dt>
                <i className="fa fa-star fa-fw" /> {t('Рейтинг')}:
              </dt>
              <dd>
                <span className="text-success">
                  {this.props.rating.ratingStatusPoints}/
                  {this.props.rating.ratingStatusPointsTo} (
                  {this.props.rating.ratingStatusTitle})
                </span>
              </dd>
              <dt>
                <i className="fa fa-calendar fa-fw" /> {t('Дата регистрации')}:
              </dt>
              <dd>{formatter.dateFormat1(this.props.createdAt)}</dd>
              <dt>
                <i className="fa fa-calendar-check-o fa-fw" />{' '}
                {t('Дата последней активности')}:
              </dt>
              <dd>{formatter.dateFormat1(this.props.lastAuthAt)}</dd>
              <dt>
                <i className="fa fa-calendar fa-fw" /> {t('Возраст')}:
              </dt>
              <dd>{formatter.emptyReplace(this.props.birthDtYearsOld)}</dd>
              <dt>
                <i className="fa fa-female fa-fw" /> {t('Пол')}:
              </dt>
              <dd>
                {formatter.emptyReplace(this.props.genderLabel.shortTitle)}
              </dd>
              <dt>
                <i className="fa fa-map-marker fa-fw" /> {t('Город')}:
              </dt>
              <dd>
                {this.props.location.countryName &&
                this.props.location.cityName ? (
                  <span>
                    {this.props.location.countryName},{' '}
                    {this.props.location.cityName}
                  </span>
                ) : (
                  <span>-</span>
                )}
              </dd>
              <dt>
                <i className="fa fa-user fa-fw" /> {t('Рефер')}:
              </dt>
              <dd>
                {this.props.referrer.id ? (
                  <NavLink to={`/users/profile/${this.props.referrer.id}`}>
                    <i className="fa fa-user" />
                    {` ${this.props.referrer.username}`}
                  </NavLink>
                ) : (
                  <span>{t('Нет').toLocaleLowerCase()}</span>
                )}
              </dd>
            </dl>
          </div>
          <div className="panel-footer">
            <div className="hor-scroll hor-scroll_always hor-scroll_sub">
              <div className="hor-scroll-wrapper">
                <NavLink
                  to="/earn-money/finished-tasks"
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Выполнил заданий')}
                >
                  <div className="counter-val">
                    {
                      this.props.tasksCountStat.myExecutionsStat
                        .countExecFinished
                    }
                  </div>
                  <div className="counter-label">{t('Выполнил')}</div>
                </NavLink>
                <NavLink
                  to="/my-tasks/all-tasks"
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Создал заданий')}
                >
                  <div className="counter-val">
                    {this.props.tasksCountStat.countMyTasks}
                  </div>
                  <div className="counter-label">{t('Заказал')}</div>
                </NavLink>
                <NavLink
                  to="/referral-program/my-stat"
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Привлек рефералов')}
                >
                  <div className="counter-val">
                    {this.props.referralsCountStat.count}
                  </div>
                  <div className="counter-label">{t('Рефералов')}</div>
                </NavLink>
                <NavLink
                  to="/main/my-page/comments-from-user"
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Прокомментаривал, оценил')}
                >
                  <div className="counter-val">
                    {this.props.commentsOutCountStat.total}
                  </div>
                  <div className="counter-label">{t('Отзывы')}</div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="panel panel-default visible-xs visible-sm">
          <div className="panel-bar bg-main">
            <div className="hor-scroll hor-scroll_xs">
              <ul className="nav nav-tabs nav-tabs-lg hor-scroll-wrapper">
                <ListItemLink to="/main/my-page/comments">
                  {t('Отзывы о пользователе')}{' '}
                  <span className="badge">
                    {this.props.commentsInCountStat.total}
                  </span>
                </ListItemLink>
                <ListItemLink to="/main/my-page/comments-from-user">
                  {t('Оценки, комментарии')}{' '}
                  <span className="badge">
                    {this.props.commentsOutCountStat.total}
                  </span>
                </ListItemLink>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

UserInfoBlock.defaultProps = {
  fullName: null,
  birthDtYearsOld: null,
  genderLabel: {
    shortTitle: null
  },
  referrer: {},
  location: {}
};

UserInfoBlock.propTypes = {
  userId: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  fullName: PropTypes.string,
  avatarPath: PropTypes.string.isRequired,
  rating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    ratingStatusTitle: PropTypes.string.isRequired,
    ratingStatusPoints: PropTypes.number.isRequired,
    ratingStatusPointsTo: PropTypes.number.isRequired
  }).isRequired,
  referrer: PropTypes.shape({
    id: PropTypes.number,
    username: PropTypes.string
  }),
  location: PropTypes.shape({
    countryName: PropTypes.string,
    cityName: PropTypes.string
  }),
  tasksCountStat: PropTypes.shape({
    countMyTasks: PropTypes.number.isRequired,
    myExecutionsStat: PropTypes.shape({
      countExecFinished: PropTypes.number.isRequired
    })
  }).isRequired,
  referralsCountStat: PropTypes.shape({
    count: PropTypes.number.isRequired
  }).isRequired,
  commentsInCountStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired,
  commentsOutCountStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired,
  createdAt: PropTypes.string.isRequired,
  lastAuthAt: PropTypes.string.isRequired,
  birthDtYearsOld: PropTypes.number,
  genderLabel: PropTypes.shape({
    shortTitle: PropTypes.string
  })
};

const mapStateToProps = state => ({
  userId: selectUserId(state),
  userName: selectUserName(state),
  fullName: selectFullName(state),
  avatarPath: selectAvatarPath(state),
  rating: selectRating(state),
  referrer: selectReferrer(state),
  location: selectLocation(state),
  createdAt: selectCreatedAt(state),
  lastAuthAt: selectLastAuthAt(state),
  birthDtYearsOld: selectBirthDtYearsOld(state),
  genderLabel: selectGenderLabel(state),
  tasksCountStat: selectTasksCountStat(state),
  referralsCountStat: selectReferralsCountStat(state),
  commentsInCountStat: selectCommentsInCountStat(state),
  commentsOutCountStat: selectCommentsOutCountStat(state)
});

export default withRouter(connect(mapStateToProps)(UserInfoBlock));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyPage/UserInfoBlock/UserInfoBlock.js